import { Component, OnDestroy, OnInit } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { AuthGaurdService } from 'src/app/service/auth-gaurd.service';
import { NotificationService } from '../../service/notification.service';
import { NotificationType } from '../../enum/notification-type.enum';
import { Router } from '@angular/router';
import { ExportExcelService } from 'src/app/service/export-excel.service';
import { UploadsConfigModel } from 'src/app/models/upload/uploadsconfig.model';
import { UploadsConfigService } from 'src/app/service/uploadsconfig.service';
import { Observable, Subscription } from 'rxjs';
import { FormControl } from '@angular/forms';
import { map, startWith } from 'rxjs/operators';
import {
  dedupeAndSortByTemplateName,
  extractApiErrorMessage,
  normalizeUploadFilterValue
} from '../upload-template.util';

@Component({
  selector: 'app-uploads-create',
  templateUrl: './uploads-create.component.html',
  styleUrls: ['./uploads-create.component.css']
})
export class UploadsCreateComponent implements OnInit, OnDestroy {

  public uploadsConfigModel1 = new UploadsConfigModel();
  public columnsList: UploadsConfigModel[];
  public selectedUserDoc: UploadsConfigModel[] = [];
  public filteredTemplatesData: UploadsConfigModel[] = [];
  public loggedinUser = '';
  public recordtemp = '';
  public activeSqlQuery = '';

  filteredTemplateValues!: Observable<UploadsConfigModel[]>;
  controlSc = new FormControl();
  private filteredTemplatesData1: UploadsConfigModel[] = [];
  private subscriptions: Subscription[] = [];
  private sqlByAction: { Insert: string; Update: string } = { Insert: '', Update: '' };

  constructor(
    private router: Router,
    private uploadsConfigService: UploadsConfigService,
    public ete: ExportExcelService,
    private authGaurdService: AuthGaurdService,
    private notificationService: NotificationService
  ) { }

  ngOnInit(): void {
    this.loggedinUser = this.authGaurdService.loginUser();
    this.getTemplatesDropdown();
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  public getTemplatesDropdown(): void {
    this.subscriptions.push(
      this.uploadsConfigService.getRecordTemplatesList().subscribe(
        (response: UploadsConfigModel[]) => {
          this.filteredTemplatesData1 = response.slice();
          this.filteredTemplatesData = dedupeAndSortByTemplateName(response);
          this.filterTemplates();
        },
        (errorResponse: HttpErrorResponse) => {
          this.notificationService.sendNotification(NotificationType.ERROR, extractApiErrorMessage(errorResponse));
        }
      )
    );
  }

  filterTemplates(): void {
    this.filteredTemplateValues = this.controlSc.valueChanges.pipe(
      startWith(''),
      map(value => this._filterSC(value))
    );
  }

  private _filterSC(value: string): UploadsConfigModel[] {
    const filterValue = normalizeUploadFilterValue(value);
    return this.filteredTemplatesData.filter(item =>
      normalizeUploadFilterValue(item.uploadtemplatename).includes(filterValue)
    );
  }

  public getSelectedTemplates(val: string): string {
    this.recordtemp = val;
    if (!val) {
      return '';
    }
    const match = this.filteredTemplatesData.find(item => item.uploadtemplatename === val);
    return match ? match.uploadtemplatename : '';
  }

  public getSelectedSc(event: { option: { value: string } }): void {
    const selectedName = event.option.value;
    this.getColumns(selectedName);
    const matched = this.filteredTemplatesData.find(item => item.uploadtemplatename === selectedName);
    if (matched) {
      this.uploadsConfigModel1.recordtemplate = matched.recordtemplate;
      this.loadSqlQueryForAction(this.uploadsConfigModel1.actiontype);
    }
  }

  private cacheSqlForAction(actionType: string, sql: string): void {
    if (!actionType || !sql) {
      return;
    }
    if (actionType.toLowerCase() === 'update') {
      this.sqlByAction.Update = sql;
    } else {
      this.sqlByAction.Insert = sql;
    }
  }

  private getCachedSql(actionType: string): string {
    return actionType?.toLowerCase() === 'update'
      ? this.sqlByAction.Update
      : this.sqlByAction.Insert;
  }

  public onActionTypeChange(actionType: string): void {
    this.cacheSqlForAction(this.uploadsConfigModel1.actiontype, this.activeSqlQuery || '');
    this.uploadsConfigModel1.actiontype = actionType;
    this.activeSqlQuery = this.getCachedSql(actionType) || '';
    this.uploadsConfigModel1.sqlquery = this.activeSqlQuery;
    if (this.activeSqlQuery) {
      return;
    }
    this.loadSqlQueryForAction(actionType);
  }

  private loadSqlQueryForAction(actionType: string): void {
    const recordTemplate = this.uploadsConfigModel1.recordtemplate;
    if (!recordTemplate || !actionType) {
      return;
    }
    this.subscriptions.push(
      this.uploadsConfigService.getSqlQueryForAction(recordTemplate, actionType).subscribe(
        (response: { sqlquery: string }) => {
          if ((this.uploadsConfigModel1.actiontype || '').toLowerCase() !== actionType.toLowerCase()) {
            return;
          }
          const sql = (response?.sqlquery || '').trim();
          this.cacheSqlForAction(actionType, sql);
          this.activeSqlQuery = sql;
          this.uploadsConfigModel1.sqlquery = sql;
        },
        (errorResponse: HttpErrorResponse) => {
          this.notificationService.sendNotification(NotificationType.ERROR, extractApiErrorMessage(errorResponse));
        }
      )
    );
  }

  redirect(url: string): void {
    this.router.navigate(['/' + url]);
  }

  downloadExcelHeaders(): void {
    if (!this.uploadsConfigModel1.recordtemplate) {
      this.notificationService.sendNotification(NotificationType.ERROR, 'Please select a record template');
      return;
    }
    if (!this.uploadsConfigModel1.actiontype) {
      this.notificationService.sendNotification(NotificationType.ERROR, 'Please select Insert or Update');
      return;
    }
    const fileTitle = this.uploadsConfigModel1.actiontype === 'Update'
      ? 'UploadsConfig_Update'
      : 'UploadsConfig_Insert';
    this.subscriptions.push(
      this.uploadsConfigService.getRecordsListForAction(
        this.uploadsConfigModel1.recordtemplate,
        this.uploadsConfigModel1.actiontype
      ).subscribe(
        (response: UploadsConfigModel[]) => {
          this.ete.exportHeaderOnlyTemplate(fileTitle, response);
        },
        (errorResponse: HttpErrorResponse) => {
          this.notificationService.sendNotification(NotificationType.ERROR, extractApiErrorMessage(errorResponse));
        }
      )
    );
  }

  public insertTemplate(): void {
    this.cacheSqlForAction(this.uploadsConfigModel1.actiontype, this.activeSqlQuery || '');
    this.uploadsConfigModel1.sqlquery = this.activeSqlQuery;
    if (!this.uploadsConfigModel1.uploadtemplatename) {
      this.notificationService.sendNotification(NotificationType.ERROR, 'Please enter record template');
    } else if (!this.uploadsConfigModel1.actiontype) {
      this.notificationService.sendNotification(NotificationType.ERROR, 'Please select insert/update');
    } else if (!this.activeSqlQuery) {
      this.notificationService.sendNotification(NotificationType.ERROR, 'Please enter query');
    } else {
      const matchedTemplate = this.filteredTemplatesData1.find(
        item => item.uploadtemplatename === this.uploadsConfigModel1.uploadtemplatename
      );
      this.selectedUserDoc = [];
      for (const updatePlan of this.columnsList) {
        updatePlan.uploadtemplatename = this.uploadsConfigModel1.uploadtemplatename;
        updatePlan.recordtemplate = matchedTemplate.recordtemplate;
        updatePlan.uploadtemplatedesc = this.uploadsConfigModel1.uploadtemplatedesc;
        updatePlan.transformationroutine = this.uploadsConfigModel1.transformationroutine;
        updatePlan.actiontype = this.uploadsConfigModel1.actiontype;
        updatePlan.sqlquery = this.activeSqlQuery;
        updatePlan.created_by = this.loggedinUser;
        this.selectedUserDoc.push(updatePlan);
      }
      this.subscriptions.push(
        this.uploadsConfigService.saveTemplate(this.selectedUserDoc).subscribe(
          () => {
            this.notificationService.sendNotification(NotificationType.SUCCESS, 'Added successfully');
            this.selectedUserDoc = [];
          },
          (errorResponse: HttpErrorResponse) => {
            this.notificationService.sendNotification(NotificationType.ERROR, extractApiErrorMessage(errorResponse));
          }
        )
      );
    }
  }

  public getColumns(val: string): void {
    this.subscriptions.push(
      this.uploadsConfigService.getColumnsList(val).subscribe(
        (res: UploadsConfigModel[]) => {
          this.columnsList = res;
        },
        (errorResponse: HttpErrorResponse) => {
          this.notificationService.sendNotification(NotificationType.ERROR, extractApiErrorMessage(errorResponse));
        }
      )
    );
  }

  trackByColumnIndex(index: number): number {
    return index;
  }

  trackByUploadTemplateName(_index: number, option: UploadsConfigModel): string {
    return option.uploadtemplatename;
  }
}
